import React from "react";
import { Link } from "react-router-dom";
import useAdInfo from "./useAdInfo";

// The "advertise on our kiosks" card under the template card, for businesses rather
// than print customers. Same markup as TemplateCta; .is-ads gives it green (App.css).
// Hidden until admins turn ads on, which waits for the kiosks to show them.
const AdCta = () => {
  const { state } = useAdInfo();
  if (state !== "ready") return null;

  return (
    <Link to="/advertise" className="template-cta is-ads">
      <span className="template-cta-icon">
        <i className="fas fa-bullhorn"></i>
      </span>
      <span className="template-cta-body">
        <span className="template-cta-title">
          <span className="template-cta-badge">Бизнест</span>
          Киоск дээр реклам байршуулах
        </span>
        <span className="template-cta-text">
          Хэвлэхээр ирсэн хүн бүрийн хардаг дэлгэц дээр брэндээ харуулаарай
        </span>
        <span className="template-cta-tags">
          <span>Брэнд</span>
          <span>Бүтээгдэхүүн</span>
          <span>Үйлчилгээ</span>
        </span>
      </span>
      <span className="template-cta-go">
        Дэлгэрэнгүй
        <span className="template-cta-arrow">
          <i className="fas fa-arrow-right"></i>
        </span>
      </span>
    </Link>
  );
};

export default AdCta;
